// extracted by mini-css-extract-plugin
module.exports = {"checkbox_container":"CheckboxLabel_checkbox_container__15v4p","checkbox_label_text":"CheckboxLabel_checkbox_label_text__OuF2e"};